/**
 * Достаёт читаемый текст из чего угодно, что прилетело в `catch`.
 *
 * В оверлее ошибки приходят в трёх видах: обычный `Error`, строка от
 * `rejectWithValue` (её и бросает `.unwrap()`) и объект ошибки Supabase
 * `{ message, code, details, hint }`. Наивный `String(error)` на третьем случае
 * даёт «[object Object]» — а этот текст попадает и в журнал, и на экран оператору.
 */
export function toErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;

  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String((error as { message: unknown }).message);
  }

  return String(error);
}
